import React, { useRef } from 'react';

import Tooltip from '@atlaskit/tooltip';

import { Link } from '@qality/common-components/src/atoms/Link';
import { Text } from '@qality/common-components/src/atoms/Text';
import { ReportTestCycleCell } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';
import { useIsOverflow } from '@qality/common-utils';

import { LinkWrapperStyled } from './ReportColumn.styled';

type Props = {
  cell: ReportTestCycleCell;
};

export default function ReportTestCycleColumn({ cell }: Props): JSX.Element {
  const ref = useRef();
  const { isOverflow } = useIsOverflow(ref);

  if (cell !== null) {
    return (
      <Tooltip content={isOverflow && cell.name} testId='tooltip'>
        <LinkWrapperStyled innerRef={ref}>
          <Link
            href={StorageOfUniqueServices.get('URLService').getTestCycleUrl(
              cell.id
            )}
            onClick={(e) => {
              e.stopPropagation();
            }}
            gray
            target='_blank'
          >
            {cell.name}
          </Link>
        </LinkWrapperStyled>
      </Tooltip>
    );
  }

  return <Text inactive>None</Text>;
}
